import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const UserManagement = () => {
  const [newUserData, setNewUserData] = useState({
    email: "",
    fullName: "",
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { user, addAuthorizedUser } = useAuth();

  if (user?.role !== "superadmin") return null;

  const handleAddUser = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!newUserData.email || !newUserData.fullName) {
      setErrorMessage("Please provide both email and full name");
      return;
    }

    const tempPassword = await addAuthorizedUser(
      newUserData.email,
      newUserData.fullName
    );

    if (tempPassword) {
      setSuccessMessage(`User added! Temporary password: ${tempPassword}`);
      setNewUserData({ email: "", fullName: "" });
      setTimeout(() => setSuccessMessage(""), 5000);
    } else {
      setErrorMessage("Failed to add user. Please try again.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md max-w-md">
      <h2 className="text-[#4C4D5E] mb-4 text-lg font-semibold">
        User Management
      </h2>

      <form onSubmit={handleAddUser} className="space-y-3 mb-4">
        <div className="grid gap-3">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-[#4C4D5E] mb-1"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={newUserData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              className="w-full px-3 py-1.5 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent text-sm"
              required
            />
          </div>

          <div>
            <label
              htmlFor="fullName"
              className="block text-sm font-medium text-[#4C4D5E] mb-1"
            >
              Full Name
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={newUserData.fullName}
              onChange={handleChange}
              placeholder="Enter full name"
              className="w-full px-3 py-1.5 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#0C60F2] focus:border-transparent text-sm"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full px-4 py-1.5 bg-[#0C60F2] text-white rounded-md hover:bg-[#0A4ED1] transition-colors text-sm"
        >
          Add New User
        </button>
      </form>

      {successMessage && (
        <div className="bg-green-50 text-green-600 p-2 rounded-md mb-3 text-sm">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="bg-red-50 text-red-600 p-2 rounded-md mb-3 text-sm">
          {errorMessage}
        </div>
      )}

      <div className="mt-3">
        <p className="text-xs text-gray-600">
          Note: New users will need to change their password upon first login.
          The temporary password will be displayed after successful user creation.
        </p>
      </div>
    </div>
  );
};

export default UserManagement;